<template>
  <section id="partners">
    <ul class="partners">
      <li v-for="(partner, i) in partners" :key="i">
        <a :href="partner.hrefUrl" :title="partner.altText" rel="noopener noreferrer" target="_blank">
          <img :src="partner.imgUrl" :alt="partner.altText" />
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: "Partners",
  props: {
    partners: Array,
  },
}
</script>

<style scoped lang="scss">
.partners {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  background-color: white;

  li {
    max-width: 11.5rem;
    height: 3rem;
    padding: 0 0.75rem;
    margin: 0.25rem auto;
  }

  img {
    height: 100%;
    object-fit: contain;
  }

  a {
    transition: opacity 250ms;

    &:hover {
      opacity: 0.85;
    }
  }
}
</style>
